import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Modal, Dropdown, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { mainAxios } from "../../middleware/interceptor";
import dayjs from "dayjs";
import ExcelJS from "exceljs";
import CustomTable from '../../CustomTable';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import Inventories from './Inventories';
import InventoriesInfo from './InventoriesInfo';
import PrintInventoryDetails from '../PrintInventoryDetails';

const InventoriesPropsInterface = {
  Id: '',
  InventoryId: '',
  Name: '',
  InventoryDate: ''
}

const InventoriesDetails = () => {
  // const [RestID, setRestID] = useState('');
  // const [Budget_Exist_Status, setBudget_Exist_Status] = useState('');
  const [IsModalOpenbudget, setIsModalOpenbudget] = useState(false);
  const [openInventories, setOpenInventories] = useState(1);
  const [counSheetList, setCountSheetList] = useState([]);
  const [inventoryDetails, setInventoryDetails] = useState(InventoriesPropsInterface)
  const [inventory, setinventory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenone, setIsModalOpenOne] = useState(false);
  const [IsModalOpentwo, setIsModalOpentwo] = useState(false);
  const [backupData, setBackupData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [load, setload] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const [inventoryBackupData, setInventoryBackupData] = useState([]);
  const [showInventoryWarningModal, setShowInventoryWarningModal] = useState(false);
  const [showPrintElement, setShowPrintElement] = useState(false);

  const UserClaims = localStorage.getItem('UserClaims');
  const RestID = localStorage.getItem('RestId');
  const Budget_Exist_Status = JSON.parse(UserClaims)?.Budget_Exist_Status;

  const navigate = useNavigate();
  const printRef = useRef();

  const items = [
    {
      key: "1",
      label: 'Export',
      onClick: (Budget_Exist_Status == 1 ? () => handleExcelDownload() : () => setIsModalOpenbudget(true))
    },
    {
      key: "2",
      label: 'Print PDF',
      onClick: (Budget_Exist_Status == 1 ? () => setShowPrintElement(true) : () => setIsModalOpenbudget(true))
    },
  ];

  const currentDate = new Date();
  const Inventory_date =
    currentDate.getFullYear() +
    "-" +
    ("0" + (currentDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + currentDate.getDate()).slice(-2);

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const getDynamicColumns = (data) => {
    const categoryKeys = [...new Set(data.flatMap(row =>
      Object.keys(row).filter(key => !["date", "type", "status", "Total", "inventoryList"].includes(key))
    ))];

    const estimateColumnWidth = (text, minWidth = 100, maxWidth = 300) => {
      const estimatedWidth = text.length * 10;
      return Math.max(minWidth, Math.min(estimatedWidth, maxWidth));
    };

    const staticColumns = [
      {
        accessorKey: "date",
        header: "Date",
        size: 100,
        muiTableHeadCellProps: { align: "left" },
        Cell: ({ row }) => row.original.date
          ? `${dayjs(row.original.date).format("MM/DD/YYYY")} (${row?.original?.inventoryList?.length})`
          : '',
      },
      {
        accessorKey: "type",
        header: "Type",
        size: 100,
        muiTableHeadCellProps: { align: "left" },
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 100,
        muiTableHeadCellProps: { align: "left" },
        muiTableBodyCellProps: { align: "center" },
        filterVariant: "select",
        filterSelectOptions: [
          { label: "Select", value: "" },
          { label: "Open", value: "Open" },
          { label: "Closed", value: "Closed" },
        ],
        Cell: ({ row }) => (
          <span
            style={{
              cursor: "pointer",
              color: !row.getCanExpand() ? (row.original.status === "Closed" ? "#22AF41" : "#9B9B9B") : '',
            }}
          >
            {row.original.status}
          </span>
        ),
      },
    ];

    const categoryColumns = categoryKeys.map((category) => ({
      accessorKey: category,
      header: category.charAt(0).toUpperCase() + category.slice(1),
      size: estimateColumnWidth(category.charAt(0).toUpperCase() + category.slice(1)),
      muiTableHeadCellProps: { align: "left" },
      muiTableBodyCellProps: { align: "right" },
      Cell: ({ row }) => <span>{currencyFormatter.format(row.original[category] || 0)}</span>,
    }));

    const totalColumn = {
      accessorKey: "Total",
      header: "Total",
      size: 100,
      muiTableHeadCellProps: { align: "left" },
      muiTableBodyCellProps: { align: "right" },
      Cell: ({ row }) => (
        <span style={{}}>
          {currencyFormatter.format(row.original.Total)}
        </span >
      ),
    };

    return [...staticColumns, ...categoryColumns, totalColumn];
  };

  const columns = useMemo(() => getDynamicColumns(inventoryData), [inventoryData]);

  const tableProps = {
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        if (!row.getCanExpand()) {
          let details = {
            ...InventoriesPropsInterface,
            Id: row?.original?.InventoryId,
            Name: row?.original?.type,
            InventoryId: row?.original?.Date_Sortkey,
            InventoryDate: row?.original?.InventoryDate,
            Status: row?.original?.status
          }
          setInventoryDetails(details);
          // RowClickNavigator();
          setOpenInventories(2)
        }
      },
      sx: { cursor: !row.getCanExpand() ? "pointer" : '' },
    }),
    muiExpandButtonProps: ({ row }) => ({
      children: row.getIsExpanded() ? <IndeterminateCheckBoxRoundedIcon fontSize='small' /> : <AddBoxRoundedIcon fontSize='small' />,
    }),
    muiExpandAllButtonProps: ({ table }) => ({
      children: table.getIsAllRowsExpanded() ? <IndeterminateCheckBoxRoundedIcon fontSize='small' /> : <AddBoxRoundedIcon fontSize='small' />,
    }),
    displayColumnDefOptions: {
      'mrt-row-expand': {
        size: 10, //make the expand column wider
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          alignSelf: 'center'
        }}
      >
        <div style={{ display: 'flex', gap: '20px' }}>
          <div>
            <Dropdown
              menu={{
                items: counSheetList,
                onClick: CreateNewInventory
              }}
              trigger={['click']}
              disabled={counSheetList.length === 0 || isLoading}
            >
              <Button
                className='printButton'
                icon={<AddIcon />}
                loading={load}
              // disabled={inventory?.length == 0 ? true : false}
              // onClick={() => { CreateNewCountSheet() }}
              >
                <Space>
                  Enter a Count
                </Space>
              </Button>
            </Dropdown>
          </div>
          <div>
            {/* <Dropdown
                menu={{ items }}
                trigger={['click']}
              >
                <Button className='printDropdown' icon={<FileDownloadRoundedIcon />}>
                  <Space>
                    Export
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown> */}
            <Button
              className='printDropdown'
              icon={<FileDownloadRoundedIcon />}
              onClick={
                Budget_Exist_Status == 1
                  ? () => handleExcelDownload()
                  : () => setIsModalOpenbudget(true)
              }
            >
              <Space>
                Export
              </Space>
            </Button>
          </div>
        </div>
      </div>
    )
  };

  const handleInit = async (key) => {
    let categoryData;
    await mainAxios.get(`api/Inventory/Getcategories/${RestID}`).then((res) => {
      categoryData = res?.data?.Categorydetails;
    }).catch((err) => {
      categoryData = [];
      console.error(err);
    });

    await mainAxios.get(`api/Inventory/getAllInventories/${RestID}`).then((res) => {
      if (res?.data?.status === 1) {
        const data = res?.data?.inventoriesList;

        const addedCatData = data.map(item => {
          const categoryAmountMap = Object.fromEntries(item.CategoriesAmountList.map(cat => [cat.CatId, cat.TotalAmount]));

          const catAmountList = categoryData.map(cat => ({
            CatId: cat.Cat_id,
            CatName: cat.Cat_name,
            TotalAmount: categoryAmountMap[cat.Cat_id] || 0
          }));

          return {
            ...item,
            CategoriesAmountList: catAmountList,
            Total: catAmountList.reduce((sum, cat) => sum + cat.TotalAmount, 0)
          };
        });

        const groupedData = addedCatData.reduce((acc, item) => {
          (acc[item.InventoryDate] ||= []).push(item);
          return acc;
        }, {});

        const transformInventories = (data) => {
          return Object.entries(data).map(([date, inventories]) => {
            const categoryKeys = [...new Set(inventories.flatMap(inv => inv.CategoriesAmountList.map(cat => cat.CatName)))];

            const initializeCategories = () =>
              Object.fromEntries(categoryKeys.map(key => [key, 0]));

            const type = inventories.length > 1
              ? "Multiple Inventories"
              : inventories[0].CountSheetName || "General Inventory";

            const status = inventories.some(inv => inv.Status === "Open") ? "Open" : "Closed";

            const mainInventory = inventories.reduce((acc, inv) => {
              inv.CategoriesAmountList.forEach(cat => {
                const key = cat.CatName;
                acc[key] = (acc[key] || 0) + cat.TotalAmount;
              });
              acc.Total += inv.Total;
              return acc;
            }, { date, type, status, Total: 0, ...initializeCategories() });

            mainInventory.inventoryList = inventories.map(inv => (
              {
                date: '',
                type: inv.CountSheetName || "General Inventory",
                status: inv.Status,
                Total: inv.Total,
                RestId: inv.RestId,
                InventoryDate: inv.InventoryDate,
                Date_Sortkey: inv.Date_Sortkey,
                InventoryId: inv.InventoryId,
                ...initializeCategories(),
                ...Object.fromEntries(inv.CategoriesAmountList.map(cat => [cat.CatName, cat.TotalAmount]))
              }
            ));
            return mainInventory;
          });
        };

        const inventoriesArray = transformInventories(groupedData);
        inventoriesArray.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });
        setInventoryData(inventoriesArray);
        setInventoryBackupData(inventoriesArray);
        if (key) {
          reRenderInventory(inventoriesArray, key);
        }
        setIsLoading(false)
      } else {
        setIsLoading(false);
        setInventoryData([]);
        setInventoryBackupData([]);
      }
    }).catch((err) => {
      console.log(err)
    });
  };

  const handleExcelDownload = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("HistoryDetails");

    const excelData = inventoryData.map(item =>
      item.inventoryList.map(({
        Date_Sortkey, InventoryId, InventoryDate, date, status, type, RestId,
        ...rest
      }) => ({
        ...rest,
        Status: status,
        Type: type,
        Date: InventoryDate
      }))
    ).flat();

    const headerRow = worksheet.addRow([
      "Date",
      "Type",
      "Status",
      ...Object.keys(excelData[0]).filter(item => !['Date', 'Type', 'Status', 'Total'].includes(item)),
      "Total",
    ]);
    headerRow.font = { bold: true };

    const excludedKeys = ["Date", "Type", "Status", "Total"];

    excelData.forEach((item) => {
      worksheet.addRow([
        dayjs(item.Date).format('MM/DD/YYYY'),
        item.Type,
        item.Status,
        ...Object.values(
          Object.fromEntries(
            Object.entries(item).filter(([key]) =>
              !excludedKeys.includes(key)))).map(value =>
                (typeof value === "number" ? currencyFormatter.format(value) : value)
              ),
        currencyFormatter.format(item.Total),
      ]);
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "InventoryHistory.xlsx";
      link.click();
    });
  };

  const IsInventoryFeatureAllowed = () => {
    // let latdata = []
    // if (Budget_Exist_Status == 1) {
    //   setIsModalOpenbudget(false);
    //   let req = {
    //     "RestId": RestID,
    //     "Inventorykey": "null",
    //     "page_status": 1
    //   }
    //   mainAxios
    //     .post('/api/Inventory', req)
    //     .then((res) => {
    //       setIsLoading(false);
    //       res.data.Data.InventoryDetails.forEach(inventories => {
    //         inventories.Items.forEach((item) => {
    //           return latdata.push(item)
    //         })

    //       });
    //       setinventory(latdata)
    //       if (latdata.length == 0) {
    //         setIsModalOpentwo(true);
    //       }
    //     })
    //     .catch((err) => {
    //       setIsLoading(false);
    //       console.log(err);
    //     });
    // }
    // else {
    //   setIsModalOpenbudget(true)
    // }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleOkprod = () => {
    setIsModalOpentwo(false);
  };

  const handleOkprodbudget = () => {
    setIsModalOpenbudget(false);
  };

  const handleCancelprod = () => {
    setIsModalOpentwo(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkone = () => {
    setIsModalOpenOne(false);
  };

  const handleCancelone = () => {
    setIsModalOpenOne(false);
  };

  const RowClickNavigator = () => {
    setOpenInventories(2);
  };

  const getAllCountSheet = () => {
    mainAxios.get(`api/Inventory/lsitCountsheets?RestId=${RestID}`)
      .then((res) => {
        if (res?.data?.status !== 0) {
          // const countsheetLabel = res?.data?.countsheetsList?.filter(item => (item.Status === 1 && item.InventoryDetails.length > 0))?.map((countsheetLabel) => {
          const countsheetLabel = res?.data?.countsheetsList?.filter(item => (item.Status === 1 && item.InventoryDetails.some(item => item.GroupedItems.length > 0)))?.map((countsheetLabel) => {
            return {
              label: countsheetLabel.CountSheetName,
              key: countsheetLabel.CountSheetId,
            };
          });
          setCountSheetList(countsheetLabel);
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err);
      });
  };

  const CreateNewInventory = (value) => {
    const checkIsInventoryExist =
      inventoryData.map(item =>
        item.inventoryList.filter(invItem =>
          invItem.status === 'Open'
        )).flat().map(finalItem => finalItem.type).includes(value.domEvent.target.innerText);

    if (checkIsInventoryExist) {
      setShowInventoryWarningModal(true);
      return;
    }

    let details = {
      ...InventoriesPropsInterface,
      Id: value.key,
      Name: value.domEvent.target.innerText
    }
    setInventoryDetails(details);
    setOpenInventories(3);
  }

  const reRenderInventory = (data, id) => {

    let list = data.flatMap(a => a.inventoryList).find(b => b.InventoryId === id);
    let details = {
      ...InventoriesPropsInterface,
      Id: list?.InventoryId,
      Name: list?.type,
      InventoryId: list?.Date_Sortkey,
      InventoryDate: list?.InventoryDate,
      Status: list?.status
    }
    setInventoryDetails(details);
    // setOpenInventories(3);
    // RowClickNavigator();
  };

  useEffect(() => {
    IsInventoryFeatureAllowed();
    getAllCountSheet();
  }, []);

  useEffect(() => {
    if (openInventories === 1) {
      handleInit();
    }
  }, [openInventories]);

  useEffect(() => {
    if (showPrintElement) {
      setTimeout(() => { printRef.current.handlePrint(); }, 500)
      setTimeout(() => { setShowPrintElement(false) }, 1500);
    }
  }, [showPrintElement]);

  return (
    <>
      <>
        <div>
          <div className="startinventoryOuter">
            <div className="startinventory">
              <div className="overallhistory">
                <>
                  {
                    Budget_Exist_Status == 0 ?
                      (<div className='nodatahis'>
                        <div className='no-inventory' style={{ height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div style={{ textAlign: 'center' }}>
                            <img style={{ width: '5em' }} src='/no-inv.png' />
                            <h2 style={{ fontSize: '18px' }}>No Inventory Found</h2>
                          </div>
                        </div>
                      </div>
                      )
                      :
                      (
                        <>
                          {openInventories === 1 && <>
                            <div className='filterParent'>
                              <div className='filterChild'>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>

                                </div>
                              </div>
                            </div>

                            <div style={{ marginTop: '10px' }} className='no_pinning'>
                              <CustomTable
                                data={inventoryData}
                                columns={columns}
                                enableTopToolbar={true}
                                enableColumnResizing={true}
                                enableRowSelection={false}
                                enableColumnActions={false}
                                enablePagination={false}
                                enableBottomToolbar={false}
                                paginateExpandedRows={true}
                                searchIconVisible={true}
                                enableGlobalFilter={true}
                                enableStickyHeader={true}
                                enableExpandAll={true}
                                initialState={{
                                  density: "compact",
                                  // pagination: { pageSize: 10 },
                                  columnPinning: {
                                    left: ['mrt-row-expand',],
                                  },
                                  expanded: true
                                }}
                                tableKey={'InventoryDetails'}
                                isLoading={isLoading}
                                enableExpanding={true}
                                getSubRows={(row) => row.inventoryList}
                                optionalProps={tableProps}
                                columnOrder={[
                                  'date',
                                  'type',
                                  'status',
                                  ...[...new Set(inventoryData.flatMap(row =>
                                    Object.keys(row).filter(key => !["date", "type", "status", "Total", "inventoryList"].includes(key))
                                  ))],
                                  'Total',
                                ]}
                              />
                            </div>
                          </>}

                          {openInventories === 2 && <>
                            <InventoriesInfo
                              CountSheetId={inventoryDetails?.Id}
                              CountSheetName={inventoryDetails?.Name}
                              InventoryDate={inventoryDetails?.InventoryDate}
                              InventoryId={inventoryDetails?.InventoryId}
                              setInventoriesDetails={setOpenInventories}
                              inventoryDetails={inventoryDetails}
                              restId={RestID}
                              handleAfterUpdate={handleInit}
                            />
                          </>
                          }

                          {openInventories === 3 && <>
                            <Inventories
                              CountSheetId={inventoryDetails?.Id}
                              CountSheetName={inventoryDetails?.Name}
                              setInventoriesDetails={setOpenInventories}
                              InventoryId={inventoryDetails?.InventoryId}
                              InventoryDate={inventoryDetails?.InventoryDate}
                              inventoryDetails={inventoryDetails}
                              restId={RestID}
                              reRenderData={handleInit}
                            />
                          </>}
                        </>
                      )
                  }
                </>
              </div>

              <Modal
                title="Set Up Your Budget"
                open={IsModalOpenbudget}
                footer={[
                  <Button
                    key="submit"
                    onClick={handleOkprodbudget}
                    style={{ backgroundColor: "#2BAB47", color: "#fff" }}
                  >
                    Got It!
                  </Button>,
                ]}
              >
                <p className="addnewcount1">
                  Please establish a budget to activate the Inventory Feature.
                </p>
              </Modal>

              <Modal
                title="Add Inventory Products"
                open={IsModalOpentwo}
                onOk={handleOkprod}
                onCancel={handleCancelprod
                }
                footer={[
                  <Button
                    key="submit"
                    onClick={handleOkprod}
                    style={{ backgroundColor: "#2BAB47", color: "#fff" }}
                  >
                    Got It!
                  </Button>,
                ]}
              >
                <p className="addnewcount1">
                  Navigate to the Products tab to add your Inventory Products. Consider uploading  recent invoices to assist in setting up your inventory.
                </p>
              </Modal>

              <Modal
                title="Open Inventory Warning"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                  <Button
                    key="submit"
                    onClick={handleOk}
                    style={{ backgroundColor: "#2BAB47", color: "#fff" }}
                  >
                    Got It
                  </Button>,
                ]}
              >
                <p className="addnewcount1">
                  An ongoing inventory process is active (not in a closed state).<br />
                  Maintain only one open inventory. Close the ongoing
                  inventory before initiating a new one.
                </p>
              </Modal>

              <Modal
                title="Warning!"
                open={isModalOpenone}
                onOk={handleOkone}
                onCancel={handleCancelone}
                footer={[
                  <Button
                    key="submit"
                    style={{ backgroundColor: "#2BAB47", color: "#fff" }}
                    onClick={handleOkone}
                  >
                    Got It
                  </Button>,
                ]}
              >
                <p className="addnewcount1">
                  Cannot save two inventories on the same date. Please select a
                  different date.
                </p>
              </Modal>

              <Modal
                title="Cannot Enter Inventory!"
                open={showInventoryWarningModal}
                onOk={() => setShowInventoryWarningModal(false)}
                onCancel={() => setShowInventoryWarningModal(false)}
                footer={[
                  <Button
                    key="submit"
                    style={{ backgroundColor: "#2BAB47", color: "#fff" }}
                    onClick={() => setShowInventoryWarningModal(false)}
                  >
                    OK
                  </Button>,
                ]}
              >
                <p className="addnewcount1">
                  There is an inventory in process (not in closed status) for the selected inventory type. You can only have one inventory open per inventory type at a time. You must close your existing inventory before starting to take a new one.
                </p>
              </Modal>

              {showPrintElement && (
                <div style={{ position: 'absolute', left: '-5000px', top: '-5000px' }}>
                  <PrintInventoryDetails
                    ref={printRef}
                    inventoryData={inventoryData}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </>

    </>
  );
};

export default InventoriesDetails;
